import { useEffect, type Dispatch, type SetStateAction, useMemo } from 'react'
import { useQueryClient } from 'react-query'

import { type Column, Table } from '../../../../../../components/Table'
import {
  fetchExperts,
  useExpertsQuery,
} from '../../../../../../services/hooks/experts/queries/useExpertQuery'
import { type FiltersDomain } from '../../../../../../types/domain/filters-domain'
import { mapExpertDomainDataToTableRow } from '../utils/mapExpertDomainDataToTableRow'

type Props = {
  filters: FiltersDomain
  columns: Column[]
  setFilters: Dispatch<SetStateAction<FiltersDomain>>
}

export const TableWithManuallyPagination = ({
  filters,
  columns,
  setFilters,
}: Props) => {
  const queryClient = useQueryClient()
  const { data, refetch } = useExpertsQuery(filters)

  const handlePageChange = (pageNumber: number) =>
    setFilters((prevState) => ({
      ...prevState,
      page: pageNumber,
    }))

  const handleChangingRegistersPerPage = (registersPerPage: number) => {
    setFilters((prevState) => ({
      ...prevState,
      page: 1,
      take: registersPerPage,
    }))
  }

  useEffect(() => {
    if (data?.meta?.hasNextPage) {
      queryClient.prefetchQuery(['experts', filters], () => {
        return fetchExperts(filters)
      })
    }
  }, [data, filters, queryClient])

  useEffect(() => {
    refetch()
  }, [])

  const formattedRows = useMemo(() => {
    return data?.data?.map(mapExpertDomainDataToTableRow)
  }, [data])

  return (
    <Table
      columns={columns}
      rows={formattedRows || []}
      currentPage={filters.page}
      registersPerPage={filters.take}
      totalCountOfRegisters={data?.meta?.itemCount}
      onPageChange={handlePageChange}
      noContentMessage="Sem registro de expert(s)"
      onChangingRegistersPerPage={handleChangingRegistersPerPage}
    />
  )
}
